

<ng-template widgets-host></ng-template>

<p-card *ngIf="!entityLoaded" header="{{ 'Loading...' | i18next }}" i18n-header>
    <fa-icon [icon]="['fas', 'spinner']" [spin]='true' size="lg"></fa-icon>
</p-card>